export default __webpack_public_path__ + "static/media/countdown.edbe2584.mp4";